import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Grid } from "../ecosystem";
import { LandingCard, PageHeading } from "../ecosystem/mybswh";

const ManageAccessLanding = (props) => {

    logUI("MBHWeb.UI.ManageAccess.ComponentDidMount", new Date(), Tools.getURLPath());

    const onClickTile = (tileName, routeName) => {
        logUI(`MBHWeb.UI.ManageAccessLanding.${tileName}.Clicked`, new Date(), Tools.getURLPath());
        if (routeName) {
            props.history.push(routeName);
        }
    };

    const headingText = "Manage Accounts & Access"
    const headingDesc = "Bring your health information together."

    const { isMyChartUser, disableMyChartMenuItems, isPrimaryUser, sessionServerData } = Tools.handleMychartUserShowOrHideMenuItems();
    const enableHappyTogether = sessionServerData && sessionServerData.enableHappyTogether ? sessionServerData.enableHappyTogether : false;
    const { proxyName } = Tools.getProxyName();


    const landingItems = [
        {
            title: "Community Accounts",
            body: "View health information from other organizations where you and your family have records.",
            to: "/communitymanage",
            show: isMyChartUser && enableHappyTogether,
            disabled: disableMyChartMenuItems,
            onClick: () => { onClickTile("CommunityAccounts"); }
        },
        {
            title: "Linked Accounts",
            body: "Connect to employer programs, health plans, or pharmacy accounts.",
            to: "/linkedaccounts",
            show: isPrimaryUser,
            onClick: () => { onClickTile("LinkedAccounts"); }
        },
        {
            title: "App & Device Access",
            body: "Manage apps and devices currently accessing your account.",
            to: "/linkeddevices",
            show: isPrimaryUser,
            onClick: () => { onClickTile("AppDeviceAccess"); }
        }
    ]
    return (
        <Grid className="body-content body-content--no-top-offset body-content--bg-gray manageaccess-landing-container">
            <div className="row">
                <div className="col-12 maxWidth-content">
                    <PageHeading bodyOffset heading={headingText} description={headingDesc} proxyName={proxyName} />
                    <div className="row">
                        {
                            landingItems.map((item, i) => {
                                {
                                   return item.show ?
                                        <div className="col-12 col-lg-4">
                                            <LandingCard {...item} />
                                        </div>
                                     : null
                                }
                            })
                        }
                    </div>
                </div>
            </div>
        </Grid>
    )
}

export default ManageAccessLanding